import { render, staticRenderFns } from "./MovementProcessingView.vue?vue&type=template&id=08cfeaf8&scoped=true"
import script from "./MovementProcessingView.vue?vue&type=script&lang=js"
export * from "./MovementProcessingView.vue?vue&type=script&lang=js"
import style0 from "./MovementProcessingView.vue?vue&type=style&index=0&id=08cfeaf8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08cfeaf8",
  null
  
)

export default component.exports